import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { DashboardComponent } from './app/pages/dashboard/dashboard.component';
import { CustomerInformationComponent } from './app/pages/customer/components/customer-information/customer-information.component';
import { ExpenseComponent } from './app/pages/expense/expense.component';
import { ProductsComponent } from './app/pages/products/products.component';
import { QueueComponent } from './app/pages/queue/queue.component';
import { LoginComponent } from './app/pages/login/login.component';
import { authGuard } from './app/shared/guards/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [authGuard]
  },
  {
    path: '',
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      {
        path: '',
        children: [
          {
            path: 'customer',
            component: CustomerInformationComponent,
            loadChildren: () => import('./app/pages/customer/customer-routing').then(mod => mod.CENTRAL_ROUTES)
          }
        ]
      },
      {
        path: '',
        children: [
          {
            path: 'queue',
            component: QueueComponent,
            loadChildren: () => import('./app/pages/queue/queue-routing').then(mod => mod.CENTRAL_ROUTES)
          }
        ]
      },
      {
        path: '',
        children: [
          {
            path: 'expense',
            component: ExpenseComponent,
            loadChildren: () => import('./app/pages/expense/expense-routing').then(mod => mod.CENTRAL_ROUTES)
          }
        ]
      },
      {
        path: '',
        children: [
          {
            path: 'products',
            component: ProductsComponent,
            loadChildren: () => import('./app/pages/products/products-routing').then(mod => mod.CENTRAL_ROUTES)
          }
        ]
      },
      {
        path: '',
        children: [
          {
            path: 'service',
            component: ProductsComponent,
            loadChildren: () => import('./app/pages/service/service-routing').then(mod => mod.CENTRAL_ROUTES)
          }
        ]
      },
      // {
      //   path: 'documents',
      //   children: [{ path: '', component: DocumentsComponent }]
      // },
      {
        path: 'calendar',
        loadComponent: () => import('./app/pages/calendar/calendar.component').then(m => m.CalendarComponent),
        loadChildren: () => import('./app/pages/calendar/calendar-routing').then(m => m.CALENDAR_ROUTES)
      }
    ]
  },
  { path: '**', redirectTo: '/' }
];
